import React, { useState, useEffect } from 'react';
import './Navigation.css';

const Navigation: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      // Get the navbar height for proper offset
      const navbar = document.querySelector('.main-navigation');
      const navHeight = navbar ? navbar.getBoundingClientRect().height : 80;
      
      // Calculate the correct scroll position
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - navHeight;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    // Close mobile menu after navigation
    setIsMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className={`main-navigation ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <div 
          className="nav-logo" 
          onClick={scrollToTop}
          style={{ cursor: 'pointer' }}
        >
          GET AI PORTRAIT
        </div>
        
        {/* Desktop Navigation */}
        <div className="nav-links desktop-nav">
          <a 
            href="#features" 
            onClick={(e) => {
              e.preventDefault();
              scrollToSection('features');
            }}
          >
            Features
          </a>
          <a 
            href="#style-gallery" 
            onClick={(e) => {
              e.preventDefault();
              scrollToSection('style-gallery');
            }}
          >
            Styles
          </a>
          <a 
            href="#pricing" 
            onClick={(e) => {
              e.preventDefault();
              scrollToSection('pricing');
            }}
          >
            Pricing
          </a>
          <a 
            href="#how-it-works" 
            onClick={(e) => {
              e.preventDefault();
              scrollToSection('how-it-works');
            }}
          >
            How It Works
          </a>
          <button 
            className="nav-cta"
            onClick={() => window.open('https://apps.apple.com/app/id6751330412', '_blank')}
          >
            Download App
          </button>
        </div>

        {/* Mobile Menu Button */}
        <button 
          className="mobile-menu-toggle"
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          <span className={`hamburger ${isMobileMenuOpen ? 'open' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
      </div>

      {/* Mobile Navigation Menu */}
      <div className={`mobile-nav ${isMobileMenuOpen ? 'open' : ''}`}>
        <a 
          href="#features" 
          onClick={(e) => {
            e.preventDefault();
            scrollToSection('features');
          }}
        >
          Features
        </a>
        <a 
          href="#style-gallery" 
          onClick={(e) => {
            e.preventDefault();
            scrollToSection('style-gallery');
          }}
        >
          Styles
        </a>
        <a 
          href="#pricing" 
          onClick={(e) => {
            e.preventDefault();
            scrollToSection('pricing');
          }}
        >
          Pricing
        </a>
        <a 
          href="#how-it-works" 
          onClick={(e) => {
            e.preventDefault();
            scrollToSection('how-it-works');
          }}
        >
          How It Works
        </a>
        <button 
          className="nav-cta mobile"
          onClick={() => window.open('https://apps.apple.com/app/id6751330412', '_blank')}
        >
          Download App
        </button>
      </div>
    </nav>
  );
};

export default Navigation;